import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';

interface ISelectLabelProps {
  icon: React.ReactNode;
  onClick?(): void;
}

export function SelectLabel({ icon, children, onClick }: React.PropsWithChildren<ISelectLabelProps>) {
  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['icon']}>{icon}</div>
      <div className={styles['content']}>
        <UIText2 color="text-main-default">{children}</UIText2>
      </div>
    </div>
  );
}
